import React from 'react'

export interface AlertBadgeContextValue {
  badges: Record<string, number>
  setBadges: (b: Record<string, number>) => void
  urgentRenewals: number
  setUrgentRenewals: (n: number) => void
  /** Spec 160 — alertes ACTIVES du client affiché, toutes sévérités : le nombre de la cloche et de la page Alertes. */
  activeCount: number
  setActiveCount: (n: number) => void
}

export const AlertBadgeContext = React.createContext<AlertBadgeContextValue>({
  badges: {},
  setBadges: () => {},
  urgentRenewals: 0,
  setUrgentRenewals: () => {},
  activeCount: 0,
  setActiveCount: () => {},
})

export function useAlertBadges(): AlertBadgeContextValue {
  return React.useContext(AlertBadgeContext)
}
